import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { StarRating } from '../ui/StarRating';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="bg-bg-secondary py-14 sm:py-16" data-id="element-206" data-mp="3mf7pges1bkaz">
      <div className="mx-auto max-w-3xl px-6 text-center sm:px-8" data-id="element-207" data-mp="3r80tt1jlcqmj">
        <SectionTag icon="⭐" data-id="element-208" data-mp="3r9ll8ialztg6">Testimonios reales</SectionTag>
        <h2 className="mt-5 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-209" data-mp="fxenz44vs9">
          Entrenadores de toda España ya lo usan.
        </h2>
        <p className="mt-3 text-base font-medium text-azul" data-id="element-210" data-mp="925qdy8n82s5">+500 reseñas verificadas</p>
      </div>

      <div className="mx-auto mt-10 grid max-w-6xl gap-5 px-6 sm:grid-cols-2 sm:px-8 lg:grid-cols-3" data-id="element-211" data-mp="e0qp1t88yeeh">
        {testimonials.map((t, i) => <m.div key={t.name} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="flex flex-col rounded-2xl border border-gris-claro bg-white p-6 shadow-leve transition-shadow duration-200 hover:shadow-media" data-id="element-212" data-mp="2autv6c0xqya1" data-mpi={i}>
            <div className="flex items-center gap-3" data-id="element-213" data-mp="1iv9a2qrbh6u7">
              <div className="flex h-[52px] w-[52px] flex-shrink-0 items-center justify-center rounded-full bg-azul font-heading text-lg font-bold text-white" data-id="element-214" data-mp="1ete7zk1kapfd">
                {t.name.charAt(0)}
              </div>
              <div data-id="element-215" data-mp="26k2c94yj8ax9">
                <p className="text-base font-semibold text-marino" data-id="element-216" data-mp="26llqyr4jidwx">{t.name}</p>
                <p className="text-sm text-gris-texto" data-id="element-217" data-mp="22hxim6833eam">{t.role}</p>
              </div>
            </div>
            <StarRating size={16} className="mt-4" data-id="element-218" data-mp="1xikl8rjl6ots" />
            <p className="mt-3 flex-1 text-base leading-relaxed text-gris-texto" data-id="element-219" data-mp="1xlyn7yoc8w0p">"{t.text}"</p>
          </m.div>)}
      </div>

      <p className="mt-8 text-center text-base font-semibold text-azul" data-id="element-220" data-mp="m3xjgxh2bsof">
        Más de 9.000 entrenadores en España ya entrenan con Balonmano Pro 360.
      </p>
    </section>;
}